import setup from "hsimp-purescript";
import language from "hsimp-purescript/language/english.json"
import characters from "hsimp-purescript/data/character-sets"
import common from "hsimp-purescript/data/common/top10k"
import patterns from "hsimp-purescript/data/patterns"


const config = {
    calculationsPerSecond: 40e9,
    namedNumbers: true,
    language: language,
    checks: {
        characterSets: characters,
        common: common,
        patterns: patterns
    }
};

let hsimp = setup(config);


export default hsimp
